import { Outlet } from "react-router-dom";

const ProtectedRouteContent = () => {
  return <Outlet />;
};

export default ProtectedRouteContent;
